"use strict";

var _createForOfIteratorHelper = require("/home/jenkins/workspace/roar-the-new-roar-ECS-Prod-2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/home/jenkins/workspace/roar-the-new-roar-ECS-Prod-2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var user_agent_1 = require("../../utils/user-agent");

var bots = require("../../../fixtures/regexes/bots.json");

var BotParser = function BotParser() {
  _classCallCheck(this, BotParser);

  this.parse = function (userAgent) {
    var _a, _b, _c, _d;

    var _iterator = _createForOfIteratorHelper(bots),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var bot = _step.value;
        var match = user_agent_1.userAgentParser(bot.regex, userAgent);
        if (!match) continue;
        return {
          name: bot.name,
          category: bot.category || "",
          url: bot.url || "",
          producer: {
            name: ((_b = (_a = bot) === null || _a === void 0 ? void 0 : _a.producer) === null || _b === void 0 ? void 0 : _b.name) || "",
            url: ((_d = (_c = bot) === null || _c === void 0 ? void 0 : _c.producer) === null || _d === void 0 ? void 0 : _d.url) || ""
          }
        };
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  };
};

module.exports = BotParser;